import styled from 'styled-components';

export const DatePickerStyle = styled.div`
  .date-picker {
    width: 100%;
    height: 100%;
    padding: 1px;
    margin-bottom: 2px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .date-range-label {
    text-align: left;
  }
  .heading {
    display: block;
    height: 15px;
    display: block;
    color: #6b6b6b;
    font-size: 12px;
    font-weight: 700;
    line-height: 15px;
    margin-top: 0;
    margin-bottom: 4px;
    margin-left: 2px;
  }
  .date-picker .kallos-date-range-container,
  .date-picker .rmdp-container {
    width: 100%;
  }
  .date-picker .kallos-form-group,
  .date-picker .kallos-form-input-group {
    height: 35px;
    min-height: 35px;
    font-size: 13px;
    box-sizing: border-box;
  }
  .date-picker .kallos-form-input-group {
    border: 2px solid #96a0a8;
    border-radius: 5px;
    align-items: center;
  }
  .date-picker .kallos-form-input-group-text {
    padding: 0 10px;
    color: #6b6b6b;
    font-size: 12px;
    align-self: stretch;
  }
  .date-picker .kallos-form-control {
    height: 31px;
    min-height: 31px;
    padding: 7px 4px 7px 0;
    box-sizing: border-box;
    color: #0f215f;
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
  }
`;
